import { Route } from '@angular/router';

import { RestorePasswordComponent } from 'app/components/restore-password/restore-password.component';

export const restorePasswordRoute: Route = {
  path: 'restore-password',
  component: RestorePasswordComponent,
  data: { title: 'Восстановление пароля' }
};
